import { render, staticRenderFns } from "./RetencaoDialog.vue?vue&type=template&id=0f295454"
import script from "./RetencaoDialog.vue?vue&type=script&lang=js"
export * from "./RetencaoDialog.vue?vue&type=script&lang=js"
import style0 from "./RetencaoDialog.vue?vue&type=style&index=0&id=0f295454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports